import EditorialInlineTruncationText from '@/components/inline-truncation-text/editorial-inline-truncation-text';
import { EatalyPlpSubcategoryTagLink } from '@/components/eataly-plp-subcategory-tag';
import { Skeleton } from '@/components/ui/skeleton';
import type { SiblingFolderLink } from '@/lib/api/content-route-index.server';
import { SubcategoryTagsContainer } from '@/components/eataly-category-plp-header/subcategory-tags-container';

type ContentFolderListingHeaderProps = {
    title: string;
    description: string;
    showTitleSkeleton: boolean;
    showDescriptionSkeleton: boolean;
    showSubcategoriesSkeleton: boolean;
    subCategoryLinks: SiblingFolderLink[];
    isSquaredCardLayout: boolean;
    onNavigateSubcategory: (target: { id: string; name: string }) => void;
};

export default function ContentFolderListingHeader({
    title,
    description,
    showTitleSkeleton,
    showDescriptionSkeleton,
    showSubcategoriesSkeleton,
    subCategoryLinks,
    onNavigateSubcategory,
    isSquaredCardLayout,
}: ContentFolderListingHeaderProps) {
    return (
        <div className="bg-neutral-white border-b border-sand-90">
            <div className="grid-global pt-3 pb-3 lg:py-8 gap-y-4 lg:gap-y-0">
                <div className="col-span-6 lg:col-start-2 lg:col-span-3">
                    {showTitleSkeleton ? (
                        <Skeleton className="h-8 w-full" />
                    ) : (
                        <h1 className="heading-display-s text-neutral-10">{title}</h1>
                    )}
                </div>

                <div className="lg:col-start-5 lg:ps-8 col-span-6 flex flex-col gap-4">
                    {showDescriptionSkeleton ? (
                        <div className="flex w-full flex-col gap-2" data-testid="plp-header-description-skeleton">
                            <Skeleton className="h-5 w-full" />
                            <Skeleton className="h-5 w-4/5" />
                        </div>
                    ) : (
                        <EditorialInlineTruncationText text={description} />
                    )}

                    {!isSquaredCardLayout && (
                        <div className="flex flex-wrap gap-2">
                            {showSubcategoriesSkeleton ? (
                                <div className="flex flex-wrap gap-2" data-testid="plp-header-subcategories-skeleton">
                                    <Skeleton className="h-10 w-24 rounded-sm" />
                                    <Skeleton className="h-10 w-28 rounded-sm" />
                                    <Skeleton className="h-10 w-20 rounded-sm" />
                                </div>
                            ) : (
                                <SubcategoryTagsContainer>
                                    {subCategoryLinks.map((link) => (
                                        <EatalyPlpSubcategoryTagLink
                                            key={link.id}
                                            label={link.title}
                                            to={link.path}
                                            isSelected={false}
                                            isCurrentPage={false}
                                            onNavigate={() => onNavigateSubcategory({ id: link.id, name: link.title })}
                                        />
                                    ))}
                                </SubcategoryTagsContainer>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
